import { Card } from 'antd';

const SmallCard = ({ title, image, description, center = false}) => {  
	return (
		<>
			<Card className='SmallCard' style={{ textAlign: center ? 'center' : 'start'}}>
				<div style={{ paddingBottom: '10px' }}>
					<img loading="lazy" src={image} alt='placeholder'/>
				</div>
				<div style={{ paddingBottom: '10px' }}>
					<span className='s3-subtitle-600' style={{ fontSize: '20px' }}>{title}</span>
				</div>
				<div 
					className='b6-body-400'
					dangerouslySetInnerHTML={{ __html: description }}
				/>
			</Card>
		</>
	);
};

export default SmallCard